import React from 'react';
import PropTypes from 'prop-types';

import { H3, Link, Image } from 'components/atoms';
import { Card } from '../Card';

import { getPSPLinksData } from 'pages/PSPPage/utils/getPSPLinksData';

import './PSPLinksCardGrid.scss';

export default function PSPLinksCardGrid({ links, pageType = 'PSP'  }) {
	if (!Array.isArray(links) || links.length === 0) {
		return null;
	}

	const cards = getPSPLinksData(links);
	return (
		<div className="psp-links-hero">
			<div className="psp-container">
				{cards.map(({ title, image, link }) => (
					<Link
						key={title}
						href={link}
						hideBorder='hideBorder'
					>
						<Card className={`card-size ${pageType === 'SGP' ? 'sgp-card' : ''}`}>
							<Image
								src={image}
								alt={title}
								height="60"
								width="60"
							/>
							<H3 className="psp-card-text">{title}</H3>
						</Card>
					</Link>
				))}
			</div>
		</div>
	);
}

PSPLinksCardGrid.propTypes = {
	links: PropTypes.arrayOf(PropTypes.string).isRequired,
	pageType: PropTypes.string,
}

